import { Box, Tab, Tabs, Typography, useTheme } from '@mui/material'
import React, { SyntheticEvent, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch } from '../../../../../../store'
import { MetricsActions, MetricsSelector } from '../../../../../../store/TechnologyMetrics'
import { GrantsMetrics } from '../../sharedComponents/GrantsMetrics'
import { ListGridToggleButtons } from './ListGridToggleButtons'
import { PipelineGrants } from './PipelineGrants'
import { PipelinePF } from './PipelinePF'

const TAB_HEADER = ['Grants', 'Private Foundations']

export const Pipeline = () => {
  const theme = useTheme()
  const { projectId = '' } = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const [selectedTab, setSelectedTab] = useState('Grants')
  const [view, setView] = useState<'list' | 'grid'>('grid')

  const metrics = useSelector(MetricsSelector.makePipelineGrantsMetrics)

  const fetchGrants = useCallback(() => {
    if (projectId) {
      dispatch(MetricsActions.fetchTechnologyMetricsAsync({ techId: projectId }))
    }
  }, [projectId, dispatch])

  useEffect(() => {
    fetchGrants()
  }, [fetchGrants])

  const handleTabChange = (event: SyntheticEvent, newTab: string) => {
    setSelectedTab(newTab)
  }

  return (
    <Box>
      <GrantsMetrics metrics={metrics} />

      <ListGridToggleButtons setActiveView={setView} activeView={view} />

      <Tabs
        value={selectedTab}
        textColor={'primary'}
        indicatorColor="primary"
        onChange={handleTabChange}
        sx={{ borderBottom: `1px solid ${theme.palette.grey[300]}` }}
      >
        {TAB_HEADER.map((header) => (
          <Tab
            key={header}
            value={header}
            label={
              <Typography
                textAlign="left"
                fontSize="0.9rem"
                textTransform="none"
                fontWeight={theme.typography.fontWeightMedium}
              >
                {header}
              </Typography>
            }
          />
        ))}
      </Tabs>

      <Box my={3}>
        {selectedTab === 'Grants' && <PipelineGrants view={view} />}
        {selectedTab === 'Private Foundations' && <PipelinePF view={view} />}
      </Box>
    </Box>
  )
}
